import individuals from './individuals';
import generations from './generations';
import samples from './samples';
import config from './config';
export default {
    individuals, 
    generations,
    samples,
    config
};


// WEBPACK FOOTER //
// ./src/reducers/index.js